import { Link } from "react-router-dom";
import { useExperience } from "../../../../../../../shared/context/ExperienceContext";
import { Icons } from "../../../../../../../shared/icons/icons";
import { getAboutWhatsAppLink } from "../../../../../../../shared/config/contact.config";
import { ArrowDrawIcon } from "../AboutDecorations/AboutDecorations.jsx";
import "./AboutCTA.css";

export default function AboutCTA({ scriptText }) {
  const { mode } = useExperience();

  const whatsappHref = getAboutWhatsAppLink(mode);

  return (
    <div className="about-preview__cta reveal-on-scroll reveal-on-scroll--up reveal-delay-4">
      <div className="about-preview__buttons">
        <Link
          to="/about"
          className="about-preview__button about-preview__button--primary"
        >
          <span>Conheça a Dionara</span>

          <span className="about-preview__button-icon">
            <Icons.ArrowRight className="about-preview__button-arrow" />
          </span>
        </Link>

        <a
          href={whatsappHref}
          target="_blank"
          rel="noreferrer"
          className="about-preview__button about-preview__button--secondary"
          aria-label="Agendar consulta pelo WhatsApp"
        >
          <span>Agendar consulta</span>

          <span className="about-preview__button-icon">
            <Icons.ArrowRight className="about-preview__button-arrow" />
          </span>
        </a>
      </div>

      <div className="about-preview__script">
        <ArrowDrawIcon />
        <p>{scriptText || "Vamos juntas nessa jornada de transformação?"}</p>
      </div>
    </div>
  );
}